export default __webpack_public_path__ + "static/media/sidebar-2.168702be.svg";